import { render, staticRenderFns } from "./NoticeActions.vue?vue&type=template&id=f8db9bb2"
import script from "./NoticeActions.vue?vue&type=script&lang=js"
export * from "./NoticeActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports